import React, { useState } from 'react';
import {
  Tooltip,
  TooltipTrigger,
  IconHelpCircle,
  ButtonIcon,
} from '@spotify-internal/encore-web';
import { IconProps } from '@spotify-internal/encore-web';

type TooltipProps = {
  text: string;
  size: IconProps['iconSize'];
};

export const HelpIconWithTooltip = ({ text, size }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <TooltipTrigger
        overlay={showTooltip && <Tooltip id="tooltip-content">{text}</Tooltip>}
        placement={TooltipTrigger.top}
        onShow={() => setShowTooltip(true)}
        onHide={() => setShowTooltip(false)}
      >
        <ButtonIcon aria-label="help">
          <IconHelpCircle iconSize={size} />
        </ButtonIcon>
      </TooltipTrigger>
    </>
  );
};
